module.exports = "<flash-messages></flash-messages>\r\n<router-outlet></router-outlet>\r\n<sd-modal-info></sd-modal-info>\r\n<sd-modal></sd-modal>\r\n"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/layouts/blank.template.html
// module id = ../../../../../src/app/layout/layouts/blank.template.html
// module chunks = main